/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setModal.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * モーダル
 */
const setModal = () => {
  let html = document.querySelector('html');
  let modalCloseBtn = document.querySelectorAll(".modal__close-btn");
  let modalCloseArea = document.querySelectorAll(".modal__close-area");
  let modalTriggers = document.querySelectorAll(".--js__modal-trigger");
  let movieModalTriggers = document.querySelectorAll(".--js__movie-modal-trigger");
  let movieInner = document.querySelector(".movie-modal__inner");

  /**
   * 
   * 処理
   * 
   *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

  //オープン
  const openModal = (e) => {
    html.classList.add("--modal--open");
    e.classList.add("--active");
  }

  //クローズ
  const closeModal = () => {
    let modalActive = document.querySelector(".--active");
    html.classList.remove("--modal--open", "--movie-modal--open");
    modalActive.classList.remove("--active");
    setTimeout(() => {
      movieInner.innerHTML = "";
    }, 500);
  }

  //動画モーダル - オープン
  const openMovieModal = (e) => {
    html.classList.add("--movie-modal--open");
    e.classList.add("--active");
  }


  /**
   * 
   * 実行
   * 
   *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

  //オープン - 対象クリック
  for (let i = 0; i < modalTriggers.length; i++) {
    modalTriggers[i].addEventListener("click", (e) => {
      let currentTarget = e.currentTarget;
      let currentModal = document.getElementById(currentTarget.dataset.modal);
      currentModal !== null && openModal(currentModal);
    });
  }

  //オープン - 動画モーダル - 対象クリック
  for (let i = 0; i < movieModalTriggers.length; i++) {
    movieModalTriggers[i].addEventListener("click", (e) => {
      let currentTarget = e.currentTarget;
      let currentModal = document.getElementById(currentTarget.dataset.modal);
      let youtubeId = currentTarget.dataset.id;
      currentModal !== null && openMovieModal(currentModal);
      movieInner.innerHTML = `<iframe src="https://www.youtube.com/embed/${youtubeId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
    });
  }

  //クローズ - 閉じるボタン
  for (let i = 0; i < modalCloseBtn.length; i++) {
    modalCloseBtn[i].addEventListener("click", () => {
      closeModal()
    });
  }

  //クローズ - 背景クリック
  for (let i = 0; i < modalCloseArea.length; i++) {
    modalCloseArea[i].addEventListener("click", () => {
      closeModal()
    });
  }

  //クローズ - ESCキー入力
  window.onkeydown = function (event) {
    html.classList.contains("--modal--open") || html.classList.contains("--movie-modal--open") ? event.keyCode == 27 && closeModal() : null;
  };
};

export {
  setModal
};